export function money(n: number | null | undefined, opts: { cents?: boolean } = {}): string {
  if (n == null) return "";
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: opts.cents ? 2 : 0, maximumFractionDigits: opts.cents ? 2 : 0 });
}
export function moneyK(n: number | null | undefined): string {
  if (n == null) return "";
  if (Math.abs(n) >= 1000) return `$${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k`;
  return money(n);
}
export function parseDate(s: string | null | undefined): Date | null {
  if (!s) return null;
  const d = new Date(s.length === 10 ? s + "T12:00:00" : s);
  return isNaN(d.getTime()) ? null : d;
}
export function shortDate(s: string | null | undefined): string {
  const d = parseDate(s);
  if (!d) return "";
  const nowY = new Date().getFullYear();
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", ...(d.getFullYear() !== nowY ? { year: "numeric" } : {}) });
}
export function monthYear(s: string | null | undefined): string {
  const d = parseDate(s);
  return d ? d.toLocaleDateString("en-US", { month: "short", year: "numeric" }) : "";
}
export function timeOfDay(s: string | null | undefined): string {
  const d = parseDate(s);
  return d ? d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) : "";
}
export function weekday(s: string | null | undefined): string {
  const d = parseDate(s);
  return d ? d.toLocaleDateString("en-US", { weekday: "short" }) : "";
}
/** "7:41 PM" if today, else "Oct 9". */
export function whenShort(s: string | null | undefined): string {
  const d = parseDate(s);
  if (!d) return "";
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return timeOfDay(s);
  return shortDate(s);
}
/** "12m", "2h", "3d". */
export function ago(s: string | null | undefined): string {
  const d = parseDate(s);
  if (!d) return "";
  const diff = Math.max(0, Date.now() - d.getTime());
  const m = Math.floor(diff / 60000);
  if (m < 1) return "now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d`;
  const mo = Math.floor(days / 30);
  if (mo < 12) return `${mo}mo`;
  return `${Math.floor(mo / 12)}y`;
}
export function dueLabel(due: string | null | undefined): { text: string; cls: string } {
  if (!due) return { text: "", cls: "" };
  const d = parseDate(due)!;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const dd = new Date(d); dd.setHours(0, 0, 0, 0);
  const diff = Math.round((dd.getTime() - today.getTime()) / 86400000);
  if (diff < 0) return { text: `${-diff}d overdue`, cls: "overdue" };
  if (diff === 0) return { text: "Today", cls: "now" };
  if (diff === 1) return { text: "Tomorrow", cls: "" };
  if (diff < 7) return { text: weekday(due), cls: "" };
  return { text: shortDate(due), cls: "" };
}
export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
}
export function titleCase(s: string | null | undefined): string {
  if (!s) return "";
  return s.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}
export const STAGES: { key: string; label: string; open: boolean }[] = [
  { key: "lead", label: "Lead", open: true },
  { key: "meeting_set", label: "Meeting set", open: true },
  { key: "discovery", label: "Discovery", open: true },
  { key: "demo", label: "Demo", open: true },
  { key: "quote_sent", label: "Quote sent", open: true },
  { key: "won_building", label: "Won: building", open: true },
  { key: "live_licensed", label: "Live: licensed", open: true },
  { key: "churned", label: "Churned", open: false },
  { key: "lost", label: "Lost", open: false },
];
export const stageLabel = (k: string | null | undefined) => STAGES.find((s) => s.key === k)?.label ?? titleCase(k);
export const SOURCES = [
  { key: "direct", label: "Direct" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "partner", label: "Partner" },
  { key: "referral", label: "Referral" },
];
export const sourceLabel = (k: string | null | undefined) => SOURCES.find((s) => s.key === k)?.label ?? titleCase(k);
export const CONTACT_ROLES = [
  { key: "decision_maker", label: "Decision maker" },
  { key: "champion", label: "Champion" },
  { key: "it", label: "IT" },
  { key: "billing", label: "Billing" },
  { key: "user", label: "User" },
];
export const roleLabel = (k: string | null | undefined) => CONTACT_ROLES.find((s) => s.key === k)?.label ?? titleCase(k);
export const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC"];
